import request from '../request';

const getOrderInfo = (id) => request({
  url: `/order-info?id=${id}`,
  method: 'GET',
  headers: {},
});

export default getOrderInfo;
